"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var icons_1 = __importDefault(require("../../../assets/icons"));
var Button_1 = require("../../atoms/Button/Button");
var TextField_1 = require("../../atoms/TextField/TextField");
var ChipArray_1 = require("../ChipArray/ChipArray");
var TagsInput_logic_1 = require("./TagsInput.logic");
var TagsInput_static_1 = require("./TagsInput.static");
/**
 * TagsInput molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-tagsinput--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/TagsInput Source}
 */
var TagsInput = function (_a) {
    var tags = _a.tags, _b = _a.tagNameValidator, tagNameValidator = _b === void 0 ? function () { return undefined; } : _b, _c = _a.tagValueValidator, tagValueValidator = _c === void 0 ? function () { return undefined; } : _c, onChange = _a.onChange, className = _a.className;
    var tagNameInputRef = (0, react_1.useRef)(null);
    var tagValueInputRef = (0, react_1.useRef)(null);
    var _d = (0, TagsInput_logic_1.useTagsInput)({
        tags: tags,
        tagNameValidator: tagNameValidator,
        tagValueValidator: tagValueValidator,
        tagNameInputRef: tagNameInputRef,
        tagValueInputRef: tagValueInputRef,
        onChange: onChange,
    }), classes = _d.classes, emptyInput = _d.emptyInput, handleAdd = _d.handleAdd, nameError = _d.nameError, valueError = _d.valueError, onChangeTagName = _d.onChangeTagName, onChangeTagValue = _d.onChangeTagValue, onKeyDown = _d.onKeyDown, tagName = _d.tagName, tagValue = _d.tagValue;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(className) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.inputsContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.textFieldContainer }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.TextField, { helperText: TagsInput_static_1.localText.helperText, placeholder: TagsInput_static_1.localText.addName, onKeyDown: onKeyDown, label: TagsInput_static_1.localText.tagName, value: tagName, onChange: onChangeTagName, inputRef: tagNameInputRef, errorText: nameError }), (0, jsx_runtime_1.jsx)(TextField_1.TextField, { helperText: TagsInput_static_1.localText.helperText, placeholder: TagsInput_static_1.localText.addValue, onKeyDown: onKeyDown, label: TagsInput_static_1.localText.tagValue, value: tagValue, onChange: onChangeTagValue, inputRef: tagValueInputRef, errorText: valueError })] })), !emptyInput && ((0, jsx_runtime_1.jsx)(Button_1.Button, { className: (0, classnames_1.default)(classes.addButton), title: TagsInput_static_1.localText.addTag, variant: 'text', icon: icons_1.default.addCompact, onClick: handleAdd }))] })), (0, jsx_runtime_1.jsx)(ChipArray_1.ChipArray, { labels: (0, lodash_1.map)(tags, function (_a) {
                    var key = _a.key, value = _a.value;
                    return "".concat(key, ": ").concat(value);
                }), onDeleteChip: function (removedIndex) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(tags.filter(function (_, index) { return index !== removedIndex; }));
                }, alwaysExpanded: true })] })));
};
exports.TagsInput = TagsInput;
